import {API_ACTION, API_SKILL_CATEGORIES, API_SKILL_CATEGORY} from '../../const/Api';
import {RestApiMethod} from '../../const/dataEnum';
import {callAPI} from './callApi';

const getByPracticeAndPeriodId = async (practiceId, periodId) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: `${API_SKILL_CATEGORIES}/${practiceId}/${periodId}`,
    });
    return res.data;
  } catch (error) {
    console.error('skillCategoryApi getByPracticeAndPeriodId Error:', error.message);
    return null;
  }
};

const create = async (departmentId, reviewPeriodId, data) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_SKILL_CATEGORY + API_ACTION.CREATE + `/${departmentId}/${reviewPeriodId}`, 
      data,
    });
    return res.data;
  } catch (error) {
    console.error('skillCategoryApi create Error:', error.message);
    return null;
  }
};

const update = async (skillCategory) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_SKILL_CATEGORY + API_ACTION.UPDATE,
      data: skillCategory,
    });
    return res.data;
  } catch (error) {
    console.error('skillCategoryApi update Error:', error.message);
    return null;
  }
};

const deleteCategory = async (skillCategory) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_SKILL_CATEGORY + API_ACTION.DELETE,
      data: skillCategory,
    });
    return res.data;
  } catch (error) {
    console.error('skillCategoryApi deleteCategory Error:', error.message);
    return null;
  }
};

const skillCategoryApi = {
  getByPracticeAndPeriodId,
  create,
  update,
  deleteCategory,
};

export default skillCategoryApi;
